export default __webpack_public_path__ + "7e382ff7898eb702e0d7d66e0faec8a5.svg";